import { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import { useNavigate } from 'react-router';

import { Grid, Card, CardHeader, Typography, Divider, CardContent, FormControl, InputLabel, MenuItem, Select, Button, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, Paper, CircularProgress, Dialog, DialogContent, DialogActions, TableContainer, Chip, DialogTitle, IconButton, Box, Badge } from '@mui/material';

import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import UndoIcon from '@mui/icons-material/Undo';

import moment from 'moment';

import { DownloadFile } from '../../helpers/DownloadFile';
import { TablePaginationActions } from '../../helpers/TablePaginationActions';

import { usePages } from '../../hooks/usePages';

import { RootState } from '../../store';

import { TableTheadStyle, TablePaddingStyle } from '../../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from '../../styles/DialogStyle';

import { Layout } from '../../components/Layout';

import { DialogAmparo } from '../../dialogs/DialogAmparo';
import { DialogDocumento } from '../../dialogs/DialogDocumento';
import { DialogExpediente } from '../../dialogs/DialogExpediente';
import { DialogExhortoRecibido } from '../../dialogs/DialogExhortoRecibido';

import { ObtenerMateria } from '../../connections/catalogos/MateriaConnection';
import { BuscarUsuariosOficiosAsignacion, BuscarUsuariosOficiosElaboro } from '../../connections/admin/UsuarioConnection';
import { ObtenerAutoridadesMaterias } from '../../connections/catalogos/AutoridadConnection';
import { ObtenerEstatus } from '../../connections/catalogos/EstatusConnection';
import { ObtenerTipoOficio } from '../../connections/catalogos/TipoOficioConnection';
import { ConsultarOficios, DescargarOficios } from '../../connections/tribunal/OficioConnection';

import { MateriaProps } from '../../interfaces/catalogos/MateriaInterface';
import { UsuarioOficiosProps } from '../../interfaces/admin/UsuarioInterface';
import { AutoridadProps } from '../../interfaces/catalogos/AutoridadInterface';
import { EstatusProps } from '../../interfaces/catalogos/EstatusInterface';
import { TipoOficioProps } from '../../interfaces/catalogos/TipoOficioInterface';
import { defaultExpediente, ExpedienteProps } from '../../interfaces/recepcion/ExpedienteInterface';
import { defaultAmparo, AmparoProps } from '../../interfaces/recepcion/AmparoInterface';
import { defaultExhortoRecibido, ExhortoRecibidoProps } from '../../interfaces/recepcion/ExhortoRecibidoInterface';
import { ConsultaOficiosProps, DestinatarioProps } from '../../interfaces/tribunal/OficioInterface';

export const OficiosPage = () => {

    const navigate = useNavigate();

    const { administrador, coordinador } = useSelector( ( state: RootState ) => state.auth );

    const [loading, setLoading] = useState( false );
    const [loadingSearch, setLoadingSearch] = useState( false );
    const [loadingDescarga, setLoadingDescarga] = useState( false );

    const [recordCount, setRecordCount] = useState( 0 );

    const [rows, setRows] = useState<ConsultaOficiosProps[]>( [] );

    const [autoridad, setAutoridad] = useState( 0 );
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>( [] );

    const [materia, setMateria] = useState( 0 );
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );

    const [usuarioElaboro, setUsuarioElaboro] = useState( 0 );
    const [usuariosElaboroArray, setUsuariosElaboroArray] = useState<UsuarioOficiosProps[]>( [] );

    const [usuarioAsignacion, setUsuarioAsignacion] = useState( 0 );
    const [usuariosAsignacionArray, setUsuariosAsignacionArray] = useState<UsuarioOficiosProps[]>( [] );

    const [estatus, setEstatus] = useState( 0 );
    const [estatusArray, setEstatusArray] = useState<EstatusProps[]>( [] );

    const [tipoOficio, setTipoOficio] = useState( 0 );
    const [tipoOficioArray, setTipoOficioArray] = useState<TipoOficioProps[]>( [] );

    const [fecha, setFecha] = useState( '' );

    const [filtroAplicado, setFiltroAplicado] = useState( false );

    const [openDialogDestinatarios, setOpenDialogDestinatarios] = useState( false );
    const [destinatariosList, setDestinatariosList] = useState<DestinatarioProps[]>( [] );

    const [openDocumento, setOpenDocumento] = useState( false );
    const [documento, setDocumento] = useState( '' );

    const [openDialogExpediente, setOpenDialogExpediente] = useState( false );
    const [expedienteSeleccionado, setExpedienteSeleccionado] = useState<ExpedienteProps>( defaultExpediente );

    const [openDialogAmparo, setOpenDialogAmparo] = useState( false );
    const [amparoSeleccionado, setAmparoSeleccionado] = useState<AmparoProps>( defaultAmparo );

    const [openDialogExhortoRecibido, setOpenDialogExhortoRecibido] = useState( false );
    const [exhortoRecibidoSeleccionado, setExhortoRecibidoSeleccionado] = useState<ExhortoRecibidoProps>( defaultExhortoRecibido );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 10 );
    const { page: pageDest, rowsPerPage: rowsPerPageDest, handleChangePage: handleChangePageDest, handleChangeRowsPerPage: handleChangeRowsPerPageDest } = usePages( 5 );

    const handleClear = () => {

        setFiltroAplicado( false );

        setMateria( 0 );
        setUsuarioElaboro( 0 );
        setUsuarioAsignacion( 0 );
        setAutoridad( 0 );
        setEstatus( 0 );
        setTipoOficio( 0 );
        setFecha( '' );

        setRows( [] );
        setRecordCount( 0 );

        resetPage();

    }

    const handleBuscar = async () => {

        setLoadingSearch( true );
        setFiltroAplicado( true );

        setRecordCount( 0 );
        resetPage();

    }

    const handleDescargar = async () => {

        setLoadingDescarga( true );

        await DescargarOficios({
            idMateria: materia,
            idUsuarioElaboro: usuarioElaboro,
            idUsuarioAsignacion: usuarioAsignacion,
            fecha: fecha ? moment( fecha ).format( 'YYYY-MM-DD' ) : '',
            idAutoridad: autoridad,
            idTipoOficio: tipoOficio,
            idEstatus: estatus,
        }).then( resp => {

            if ( resp ) {

                DownloadFile( `Oficios-${ Date.now() }.xlsx`, resp );

                setLoadingDescarga( false );

            }

        });

    }

    const handleVerDetalle = ( { amparo, exhortoRecibido, expediente }: ConsultaOficiosProps ) => {

        if ( amparo.idAmparo !== 0 ) {

            setAmparoSeleccionado( amparo );
            setOpenDialogAmparo( true );

        }
        else if ( exhortoRecibido.idExhortoRecibido !== 0 ) {

            setExhortoRecibidoSeleccionado( exhortoRecibido );
            setOpenDialogExhortoRecibido( true );

        }
        else {

            setExpedienteSeleccionado( expediente );
            setOpenDialogExpediente( true );

        }

    }

    useEffect(() => {

        async function Obtener() {

            await ObtenerMateria().then( resp => {
                setMateriaArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await BuscarUsuariosOficiosElaboro().then( resp => {
                setUsuariosElaboroArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await BuscarUsuariosOficiosAsignacion().then( resp => {
                setUsuariosAsignacionArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await ObtenerEstatus().then( resp => {
                setEstatusArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoOficio().then( resp => {
                setTipoOficioArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            setAutoridad( 0 );
            setAutoridadArray( [] );

            await ObtenerAutoridadesMaterias( materia ).then( resp => {
                setAutoridadArray( resp );
            });

        }

        Obtener();

    }, [ materia ]);

    useEffect(() => {

        async function Obtener() {

            setLoading( true );
            setRows( [] );

            await ConsultarOficios({ page, rowsPerPage, idMateria: 0, idUsuarioElaboro: 0, idUsuarioAsignacion: 0, fecha: '', idAutoridad: 0, idEstatus: 0, idTipoOficio: 0 }).then( resp => {

                setTimeout(() => {

                    setRecordCount( resp.recordsCount );
                    setRows( resp.records );

                    setLoadingSearch( false );
                    setLoading( false );

                }, 700);

            });

        }

        if ( !filtroAplicado ) {
            Obtener();
        }

    }, [ page, rowsPerPage, filtroAplicado ]);

    useEffect(() => {

        async function Obtener() {

            setLoading( true );
            setRows( [] );

            await ConsultarOficios({
                page,
                rowsPerPage,
                idMateria: materia,
                idUsuarioElaboro: usuarioElaboro,
                idUsuarioAsignacion: usuarioAsignacion,
                fecha: fecha ? moment( fecha ).format( 'YYYY-MM-DD' ) : '',
                idAutoridad: autoridad,
                idTipoOficio: tipoOficio,
                idEstatus: estatus,
            }).then( resp => {

                setTimeout(() => {

                    setRecordCount( resp.recordsCount );
                    setRows( resp.records );

                    setLoadingSearch( false );
                    setLoading( false );

                }, 700);

            });

        }

        if ( filtroAplicado ) {
            Obtener();
        }

    }, [ page, rowsPerPage, filtroAplicado, materia, fecha, usuarioElaboro, usuarioAsignacion, autoridad, estatus, tipoOficio ]);

    return (
        <Layout breadcrumbs={ [{ text: 'Consultas' }, { text: 'Oficios' }] } backgroundPaper={ false }>

            <Grid container spacing={ 3 }>

                {
                    ( administrador || coordinador )
                    &&
                        <Grid size={{ md: 12, xs: 12 }} textAlign={ 'start' }>

                            <Button startIcon={ <UndoIcon /> } color='secondary' variant='text' sx={{ mt: 1 }} onClick={ () => navigate('/') }>
                                Regresar
                            </Button>

                        </Grid>
                }

                <Grid size={{ md: 12, xs: 12 }}>

                    <Card>
                        <CardHeader
                            sx={{ backgroundColor: (theme) => theme.palette.primary.main, py: 2 }}
                            subheader={<Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Filtro(s) </Typography>}
                        />

                        <Divider />

                        <CardContent sx={{ p: 3 }}>

                            <Grid container spacing={ 3 }>

                                <Grid size={{ md: 2, xs: 12 }}>

                                    <FormControl fullWidth>
                                        <InputLabel>Materia</InputLabel>

                                        <Select
                                            label='Materia'
                                            value={ materia }
                                            onChange={ (e) => setMateria( e.target.value ) }
                                            disabled={ filtroAplicado }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                materiaArray
                                                .filter( ({ idMateria }) => idMateria === 5 || idMateria === 6 )
                                                .map( ({ idMateria, descripcion }) => (
                                                    <MenuItem key={ idMateria } value={ idMateria }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 4, xs: 12 }}>

                                    <FormControl fullWidth>
                                        <InputLabel>Autoridad</InputLabel>

                                        <Select
                                            label='Autoridad'
                                            value={ autoridad }
                                            onChange={ (e) => setAutoridad( e.target.value ) }
                                            disabled={ filtroAplicado || materia === 0 }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                autoridadArray.map( ({ idAutoridad, descripcion }) => (
                                                    <MenuItem key={ idAutoridad } value={ idAutoridad }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>

                                    <LocalizationProvider dateAdapter={ AdapterMoment } adapterLocale='es'>
                                        <DatePicker
                                            label='Fecha del oficio'
                                            sx={{ width: '100%' }}
                                            value={ fecha ? moment( fecha ) : null }
                                            maxDate={ moment( new Date() ) }
                                            onChange={ (newValue) => setFecha( newValue ? newValue.format( 'YYYY-MM-DD' ) : '' ) }
                                            disabled={ filtroAplicado }
                                            slotProps={{ textField: { InputLabelProps: { shrink: true } } }}
                                        />
                                    </LocalizationProvider>

                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>

                                    <FormControl fullWidth>
                                        <InputLabel>Tipo de oficio</InputLabel>

                                        <Select
                                            label='Tipo de oficio'
                                            value={ tipoOficio }
                                            onChange={ (e) => setTipoOficio( e.target.value ) }
                                            disabled={ filtroAplicado }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                tipoOficioArray
                                                .filter( ({ idTipoOficio }) => idTipoOficio !== 5 )
                                                .map( ({ idTipoOficio, descripcion }) => (
                                                    <MenuItem key={ idTipoOficio } value={ idTipoOficio }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 4, xs: 12 }}>

                                    <FormControl fullWidth>
                                        <InputLabel>Usuario elaboró oficio</InputLabel>

                                        <Select
                                            label='Usuario elaboró oficio'
                                            value={ usuarioElaboro }
                                            onChange={ (e) => setUsuarioElaboro( e.target.value ) }
                                            disabled={ filtroAplicado }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                usuariosElaboroArray.map( ({ id, nombreCompleto }) => (
                                                    <MenuItem key={ id } value={ id }>{ nombreCompleto }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 4, xs: 12 }}>

                                    <FormControl fullWidth>
                                        <InputLabel>Usuario asignación</InputLabel>

                                        <Select
                                            label='Usuario asignación'
                                            value={ usuarioAsignacion }
                                            onChange={ (e) => setUsuarioAsignacion( e.target.value ) }
                                            disabled={ filtroAplicado }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                usuariosAsignacionArray.map( ({ id, nombreCompleto }) => (
                                                    <MenuItem key={ id } value={ id }>{ nombreCompleto }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 2, xs: 12 }}>

                                    <FormControl fullWidth>
                                        <InputLabel>Estatus</InputLabel>

                                        <Select
                                            label='Estatus'
                                            value={ estatus }
                                            onChange={ (e) => setEstatus( e.target.value ) }
                                            disabled={ filtroAplicado }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                estatusArray
                                                .filter( ({ idEstatus }) => [ 3, 43, 44, 45 ].includes( idEstatus ) )
                                                .map( ({ idEstatus, descripcion }) => (
                                                    <MenuItem key={ idEstatus } value={ idEstatus }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 2, xs: 12 }}>

                                    <Button
                                        fullWidth
                                        variant={ filtroAplicado ? 'outlined' : 'contained' }
                                        color={ filtroAplicado ? 'secondary' : 'primary' }
                                        loading={ loadingSearch }
                                        disabled={ materia === 0 && autoridad === 0 && usuarioElaboro === 0 && usuarioAsignacion === 0 && tipoOficio === 0 && estatus === 0 && !fecha }
                                        onClick={ () => { filtroAplicado ? handleClear() : handleBuscar() } }
                                        sx={{ mt: 1, px: 5 }}
                                    >
                                        { filtroAplicado ? 'Limpiar filtro' : 'Buscar' }
                                    </Button>

                                </Grid>

                            </Grid>

                        </CardContent>

                    </Card>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }} textAlign={ 'right' }>

                    <Button
                        color='secondary'
                        variant='outlined'
                        sx={{ mt: 1 }}
                        loading={ loadingDescarga }
                        disabled={ rows.length === 0 }
                        onClick={ handleDescargar }
                    >
                        Descargar información
                    </Button>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }}>

                    <TableContainer sx={{ borderRadius: 3 }} component={ Paper }>

                        <Table sx={{ minWidth: 500 }}>

                            <TableHead sx={{ ...TableTheadStyle }}>

                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}></TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Oficio</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Referencia</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', fontWeight: 'bold', textAlign: 'center' }}>Dependencia</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold', textAlign: 'center' }}>Destinatarios</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Elaboro</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Estatus</TableCell>

                                </TableRow>

                            </TableHead>

                            <TableBody>

                                {
                                    rows.map( ( row, index ) => {

                                        const { numeroSeguimiento, fecha, numeroOficio, tipoOficio, referencia, destinatarios, dependencia, documento, idEstatus, estatus, usuarioAsignado, usuarioElaboro } = row;

                                        return (
                                        <TableRow key={ index } sx={{ '& td': { py: 2 } }}>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Typography variant='h6'>
                                                    { numeroSeguimiento }
                                                </Typography>

                                                {
                                                    fecha
                                                    &&
                                                        <>

                                                            <Typography variant='subtitle1' fontSize={ 14 }>
                                                                { moment( fecha ).format( 'DD-MM-YYYY' ) }
                                                            </Typography>

                                                            <Typography variant='caption' color='text.secondary'>
                                                                { moment( fecha ).format( 'hh:mm a' ) }
                                                            </Typography>

                                                        </>
                                                }

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>

                                                    {
                                                        documento
                                                        ?
                                                            <Button
                                                                fullWidth
                                                                variant='contained'
                                                                onClick={ () => { setDocumento( documento ); setOpenDocumento( true ); } }
                                                            >
                                                                { numeroOficio }
                                                            </Button>
                                                        :
                                                            <Typography variant='subtitle1' fontWeight={ 'bold' }>
                                                                { numeroOficio }
                                                            </Typography>
                                                    }

                                                    {
                                                        tipoOficio
                                                        &&
                                                            <Typography variant='caption' color='text.secondary' mt={ 1 }>
                                                                <strong>Tipo de oficio:</strong> <br /> { tipoOficio }
                                                            </Typography>
                                                    }

                                                </Box>

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Button
                                                    fullWidth
                                                    variant='contained'
                                                    onClick={ () => handleVerDetalle( row ) }
                                                >
                                                    { referencia }
                                                </Button>

                                            </TableCell>

                                            <TableCell>

                                                <Typography variant='subtitle2' fontSize={ 13 } sx={{ textTransform: 'uppercase' }}>
                                                    { dependencia }
                                                </Typography>

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                {
                                                    destinatarios.length !== 0
                                                    &&
                                                        <IconButton
                                                            color='primary'
                                                            onClick={ () => { setDestinatariosList( destinatarios ); setOpenDialogDestinatarios( true ); } }
                                                        >
                                                            <Badge
                                                                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                                                badgeContent={ <Typography variant='subtitle2'>{ destinatarios.length }</Typography> }
                                                                color='secondary'
                                                            >
                                                                <FormatListNumberedIcon />
                                                            </Badge>

                                                        </IconButton>
                                                }

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Typography variant='body2' fontSize={ 13 } sx={{ textTransform: 'uppercase' }}>
                                                    { usuarioElaboro }
                                                </Typography>

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Chip
                                                    variant='filled'
                                                    sx={{ fontWeight: 'bold', mb: 1 }}
                                                    color={ idEstatus === 3 ? 'primary' : 'default' }
                                                    label={
                                                        <Typography variant='subtitle1' fontWeight={ '600' } fontSize={ 13 }>
                                                            { estatus }
                                                        </Typography>
                                                    }
                                                />

                                                {
                                                    usuarioAsignado
                                                    &&
                                                        <Box sx={{ mt: 1 }}>

                                                            <Typography variant='caption' sx={{ fontWeight: 'bold', display: 'block', color: 'text.secondary' }}>
                                                                Asignado a:
                                                            </Typography>

                                                            <Typography variant='caption' sx={{ display: 'block', color: 'text.secondary', textTransform: 'uppercase', fontSize: 11 }}>
                                                                { usuarioAsignado }
                                                            </Typography>

                                                        </Box>
                                                }

                                            </TableCell>

                                        </TableRow>
                                    )})
                                }

                                {
                                    ( rows.length === 0 && !loading )
                                    ?
                                        <TableRow style={{ height: 100 }}>

                                            <TableCell colSpan={ 7 } align='center'>

                                                <Typography variant='caption' color='secondary'> No se encontraron resultados </Typography>

                                            </TableCell>

                                        </TableRow>
                                    :
                                        loading
                                        &&
                                            <TableRow style={{ height: 100 }}>

                                                <TableCell colSpan={ 7 } align='center'>

                                                    <CircularProgress size={ 26 } />

                                                </TableCell>

                                            </TableRow>
                                }

                            </TableBody>

                            <TableFooter>

                                <TableRow>

                                    <TableCell colSpan={ 2 }>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de registros: { recordCount } </Typography>
                                    </TableCell>

                                    <TablePagination
                                        colSpan={ 5 }
                                        rowsPerPageOptions={ [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500 ] }
                                        count={ recordCount }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }
                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }
                                        ActionsComponent={ TablePaginationActions }
                                        labelRowsPerPage='Filas por página'
                                        labelDisplayedRows={ ({ from, to, count }) => `${ from }-${ to } de ${ count }` }
                                    />

                                </TableRow>

                            </TableFooter>

                        </Table>

                    </TableContainer>

                </Grid>

            </Grid>

            <Dialog fullWidth maxWidth='md' open={ openDialogDestinatarios }>

                <DialogTitle> Destinatarios </DialogTitle>

                <DialogContent sx={ DialogContentStyle }>

                    <TableContainer sx={{ borderRadius: 3, mt: 1 }} component={ Paper }>

                        <Table>

                            <TableHead sx={{ ...TableTheadStyle }}>

                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, fontWeight: 'bold' }}>Nombre(s)</TableCell>

                                </TableRow>

                            </TableHead>

                            <TableBody>

                                {
                                    ( rowsPerPageDest > 0 ? destinatariosList.slice( pageDest * rowsPerPageDest, pageDest * rowsPerPageDest + rowsPerPageDest ) : destinatariosList )
                                    .map( ( dest, i ) => (
                                        <TableRow key={ i }>
                                            <TableCell>{ dest.nombreCompleto }</TableCell>
                                        </TableRow>
                                    ))
                                }

                            </TableBody>

                            <TableFooter>

                                <TableRow>

                                    <TablePagination
                                        rowsPerPageOptions={ [] }
                                        colSpan={ 6 }
                                        count={ destinatariosList.length }
                                        rowsPerPage={ rowsPerPageDest }
                                        page={ pageDest }
                                        onPageChange={ handleChangePageDest }
                                        onRowsPerPageChange={ handleChangeRowsPerPageDest }
                                        ActionsComponent={ TablePaginationActions }
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                                return '' + from + '-' + to + ' de ' + count
                                            }
                                        }
                                    />

                                </TableRow>

                            </TableFooter>

                        </Table>

                    </TableContainer>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color='secondary' onClick={ () => setOpenDialogDestinatarios( false ) }> Cerrar </Button>
                </DialogActions>

            </Dialog>

            <DialogDocumento
                documento={ documento }
                openDialog={ openDocumento }
                handleCloseDialog={ () => { setOpenDocumento( false ); setDocumento( '' ); } }
            />

            <DialogExpediente
                expediente={ expedienteSeleccionado }
                openDialog={ openDialogExpediente }
                handleCloseDialog={ () => setOpenDialogExpediente( false ) }
            />

            <DialogAmparo
                amparo={ amparoSeleccionado }
                openDialog={ openDialogAmparo }
                handleCloseDialog={ () => setOpenDialogAmparo( false ) }
            />

            <DialogExhortoRecibido
                exhortoRecibido={ exhortoRecibidoSeleccionado }
                openDialog={ openDialogExhortoRecibido }
                handleCloseDialog={ () => setOpenDialogExhortoRecibido( false ) }
            />

        </Layout>
    );
};
